// ./src/config/api.config.ts

import { getRuntimeApiUrl } from '@config/runtime.config';

/** Dev uses '' so Vite proxies /api and /game/; prod uses runtime config → VITE_API_URL → default. */
export function resolveApiBaseUrl(): string {
  const runtime = getRuntimeApiUrl();
  if (runtime) {
    return runtime.replace(/\/$/, '');
  }
  if (import.meta.env.DEV) {
    return '';
  }
  const configured = import.meta.env.VITE_API_URL?.trim();
  if (configured) {
    return configured.replace(/\/$/, '');
  }
  return 'https://be.play-studios.ai';
}

export const API_CONFIG = {
  get baseUrl() {
    return resolveApiBaseUrl();
  },
  endpoints: {
    demoToken: '/api/demo/start',
    login: '/api/auth/login',
    playerSessionStart: '/api/player/session/start',

    // Leaderboard
    leaderboard: {
      multiplier: '/api/crash/leaderboard/top/multiplierX',
      win: '/api/crash/leaderboard/top/win',
      rounds: '/api/crash/leaderboard/top/rounds',
    },

    previousRound: '/api/crash/round/previous',
    provablyFair: '/api/crash/round/provablyfair',

    /** Crash Provably Fair audit record for a single round. */
    provablyFairRound: (
      roundId: number | string,
      gameCode: number | string,
      tableNo: number | string
    ) =>
      `/api/crash/provably-fair/round/${roundId}?gameCode=${gameCode}&tableNo=${tableNo}`,
    /** Latest Provably Fair audit rows for a game (newest first). */
    provablyFairHistory: (gameCode: number | string, limit = 10) =>
      `/api/crash/provably-fair/history?gameCode=${gameCode}&limit=${limit}`,
    /** Server-side Provably Fair verifier. */
    provablyFairVerify: '/api/crash/provably-fair/verify',

    // Token Refresh
    refreshToken: '/api/auth/v1/refreshToken',
    balance: '/api/player/v1/wallet/balances',

    betHistoryRounds: (sessionId: string) =>
      `/api/player/v1/history/sessions/${sessionId}/rounds`,

    playerInfo: '/api/player/v1/profile',

    /** Player avatar catalogue + current selection. */
    playerAvatars: '/api/player/v1/avatars',
    /** Persist selected avatar for the player. */
    playerAvatarSelect: '/api/player/v1/avatars/select',

    systemAvatars: (page = 0, size = 100) =>
      `/api/bo/v1/system/avatars?page=${page}&size=${size}`,

    gameLaunch: (gameId: number) => `/game/launch/${gameId}`,
    gameEnd: (gameId: number) => `/game/end/${gameId}`,

    /** Crash table config (bet limits, etc.) for a game. */
    crashConfig: (gameId: number) => `/api/v1/crash/config/${gameId}`,
  },
};